import { Typography } from "@material-ui/core";
import React from "react";

export default () => {
  return (
    <div style={{ backgroundColor: "transparent !important" }}>
      <Typography variant="h3">List of my skills</Typography>
    </div>
  );
};
